import { displayValue } from './displayValue';

/**
 * displayList
 *
 * Formats a list for display, showing "None" for empty lists.
 *
 * Requirements: 18.2
 */
export function displayList(items: unknown[], emptyMessage = 'None'): string {
  if (!items || items.length === 0) {
    return emptyMessage;
  }

  return items.map(item => displayValue(item)).join(', ');
}